import * as React from 'react';
import {
  Autocomplete,
  AutocompleteProps,
  CancellableApiPromise,
} from './Autocomplete';

type Props = Omit<
  AutocompleteProps<string, string>,
  | 'allowCreateItems'
  | 'getNewItem'
  | 'getItemName'
  | 'getItemId'
  | 'items'
  | 'onSearchItems'
> & {
  onSearchItems: (text: string) => CancellableApiPromise<string[]>;
};

export const AutocompleteSuggestText: React.FC<Props> = ({
  onSearchItems,
  dataTest,
  ...other
}) => {
  return (
    <Autocomplete<string, string>
      dataTest={dataTest}
      {...other}
      allowCreateItems
      onSearchItems={onSearchItems}
      getItemId={(i) => i}
      getItemName={(i) => i}
      getNewItem={(text) => text}
    />
  );
};
